<div class="layer-container">
    <div class="title-container">
        <fa-icon class="layer-icon-mobile" [icon]="faLayer"></fa-icon>
        <label class="title-layer">{{ 'MAP.LAYERS.TITLE' | translate }}</label>
    </div>

    <div class="layers-selection">
        <div class="field">
            <p-checkbox binary="true" [(ngModel)]="layer.bsn" (onChange)="onLayerChange()"></p-checkbox>
            <label>{{ 'MAP.LAYERS.BSN' | translate }}</label>
        </div>
        <div class="field">
            <p-checkbox binary="true" [(ngModel)]="layer.modeles" (onChange)="onLayerChange()"></p-checkbox>
            <label>{{ 'MAP.LAYERS.MODEL' | translate }}</label>
        </div>
        <div class="field">
            <p-checkbox binary="true" [(ngModel)]="layer.piezometres" (onChange)="onLayerChange()"></p-checkbox>
            <label>{{ 'MAP.LAYERS.PIEZO' | translate }}</label>
        </div>
        <div class="field">
            <p-checkbox binary="true" [(ngModel)]="layer.pluviometres" (onChange)="onLayerChange()"></p-checkbox>
            <label>{{ 'MAP.LAYERS.RAIN' | translate }}</label>
        </div>
        <div class="field">
            <p-checkbox binary="true" [(ngModel)]="layer.hydrometrie" (onChange)="onLayerChange()"></p-checkbox>
            <label>{{ 'MAP.LAYERS.HYDRO' | translate }}</label>
        </div>
    </div>
    <div><i>{{ 'MAP.LAYERS.ZOOM_INFO' | translate }}</i></div>
    <div class="legend-consult" (click)="onLegendConsultClick()">{{ 'MAP.LAYERS.CONSULT_LEGEND' | translate }}</div>
</div>
